"use client";
import { ErrorPageContent } from "@components/errors/ErrorPageContent";
import { DocumentHead } from "templates/document/DocumentHead";
import { SvgSprite } from "templates/document/SvgSprite";
import GlobalScripts from "@lib/scripts/GlobalScripts";
import { SetScrollbarWidthVariable } from "@components/ui/set-scrollbar-width-variable/SetScrollbarWidthVariable";
import { GlobalCss } from "templates/document/GlobalCss";
import { routing } from "i18n/routing";
import { ViewportMetaClient } from "@lib/scripts/ViewportMetaClient";
import type { Viewport } from "next";
import { useEffect } from "react";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

export const viewport: Viewport = {
    width: "device-width",
    initialScale: 1,
    maximumScale: 5,
};

/*
Because global-error.tsx is the final layer of error handling we don't try to fetch any data here.
This template should be treated as a last resort when all else fails and as such should be kept as slim as possible.
It will not use any layout so we must include html, head and body tags here.
*/
export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
    useEffect(() => {
        Logger.error(ServiceType.WEB, "Global error page", {
            tag: LogTag.ERROR,
            error: Logger.errorToJson(error),
        });
    }, [error]);
    const locale = routing.defaultLocale;
    return (
        <html data-theme="light" style={{ colorScheme: "light" }} lang={locale}>
            <head>
                <DocumentHead />
            </head>
            <body
                style={{ overflowX: "hidden" }}
                // We're using light as default without detecting system.
                // Setting it initially avoid a little flicker.
                className="chakra-ui-light"
            >
                <GlobalCss />
                <SvgSprite />
                <ViewportMetaClient />
                <GlobalScripts locale={locale} />
                <SetScrollbarWidthVariable />
                <ErrorPageContent errorCode={500} />
            </body>
        </html>
    );
}
